var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyMenu = function SvgEmptyMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 135,
    viewBox: "0 0 124 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.694,
    cy: 76.3698,
    r: 58.3073,
    fill: "#EFF4F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.3073,
    cy: 69.2761,
    r: 57.9134,
    stroke: "#DCE5E1",
    strokeWidth: 0.787937
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.4279,
    height: 17.3346,
    transform: "translate(31 45)",
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.409,
    y: 44.409,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7011,
    y: 48.7334,
    width: 9.45524,
    height: 9.45524,
    rx: 1.57587,
    fill: "#EFF4F2",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3751,
    y: 49.1729,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    fill: "#EFF4F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.378,
    y: 54.6035,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    fill: "#EFF4F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42.409,
    y: 66.409,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7011,
    y: 70.7334,
    width: 9.45524,
    height: 9.45524,
    rx: 1.57587,
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60.3751,
    y: 71.1729,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    fill: "#EFF4F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60.378,
    y: 76.6035,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    fill: "#EFF4F2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 42.409,
    y: 88.409,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7011,
    y: 92.7334,
    width: 9.45524,
    height: 9.45524,
    rx: 1.57587,
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60.3751,
    y: 93.1729,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    fill: "#EFF4F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 60.378,
    y: 98.6035,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    fill: "#EFF4F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.02319,
    x2: 16.2237,
    y2: -2.02319,
    transform: "matrix(4.35189e-08 1 1 -4.39051e-08 117.705 18.1123)",
    stroke: "#FF5F5A",
    strokeWidth: 4.04637
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2.02319,
    x2: 16.1521,
    y2: -2.02319,
    transform: "matrix(-1 0 0 1 124 28.3281)",
    stroke: "#FF5F5A",
    strokeWidth: 4.04637
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1.04568,
    x2: 8.38513,
    y2: -1.04568,
    transform: "matrix(4.35189e-08 1 1 -4.39051e-08 94.0962 41)",
    stroke: "#FF5F5A",
    strokeWidth: 2.09135
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.04568,
    x2: 8.34817,
    y2: -1.04568,
    transform: "matrix(-1 0 0 1 97.3481 46.2861)",
    stroke: "#FF5F5A",
    strokeWidth: 2.09135
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1.04568,
    x2: 6.38513,
    y2: -1.04568,
    transform: "matrix(4.35189e-08 1 1 -4.39051e-08 28.8807 28)",
    stroke: "#FF5F5A",
    strokeWidth: 2.09135
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1.04568,
    x2: 6.35698,
    y2: -1.04568,
    transform: "matrix(-1 0 0 1 31.357 32.0254)",
    stroke: "#FF5F5A",
    strokeWidth: 2.09135
  })));
};
export default SvgEmptyMenu;